import Api from '../../services';

export const getActivities = (params) => {
  return (dispatch) => {
    return Api.activities.getActivities(params).then((response) => {
      dispatch({
        type: 'GET_ACTIVITIES',
        data: response,
      });
      return response;
    });
  };
};

export const getSubActivities = (id) => {
  return (dispatch) => {
    return Api.activities.getSubActivities(id).then((response) => {
      dispatch({
        type: 'GET_SUB_ACTIVITIES',
        data: response,
      });
      return response;
    });
  };
};

export const getActivitiesWithSubactivities = () => {
  return (dispatch) => {
    return Api.activities.getActivitiesWithSubactivities().then((response) => {
      dispatch({
        type: 'GET_ACTIVITIES_WITH_SUB_ACTIVITIES',
        data: response,
      });
      return response;
    });
  };
};

export const activitiesLookup = (params) => {
  return (dispatch) => {
    return Api.activities.activitiesLookup(params).then((response) => {
      dispatch({
        type: 'ACTIVITIES_LOOKUP',
        data: response,
      });
      return response;
    });
  };
};

export const getActivityDetails = (id) => {
  return (dispatch) => {
    return Api.activities.getActivityDetails(id).then((response) => {
      dispatch({ type: 'ACTIVITY_DETAILS' });
      return response;
    });
  };
};
